document.addEventListener('DOMContentLoaded', function () {
    const meter = document.querySelector('.score-meter');
  
    if (!meter) return;
  
    const maxScore = parseInt(meter.getAttribute('data-max-score'), 10);
    const valueBlock = meter.querySelector('.score-meter__value');
    const tooltip = meter.querySelector('.score-meter__tooltip');
    const valueStatus = meter.querySelector('.score-meter__status');
  
    let score = parseInt(meter.getAttribute('data-score'), 10);

    if (Number.isNaN(score)) {
      const queryParams = new URLSearchParams(window.location.search);
      const rawScore = queryParams.get('mfoscore:z5g');
      const scoreFromQuery = rawScore ? parseInt(rawScore, 10) : NaN;

      if (!Number.isNaN(scoreFromQuery)) {
        score = scoreFromQuery;
      } else {
        const storageKey = 'score_meter_fallback';
        const stored = sessionStorage.getItem(storageKey);
        const storedScore = stored ? parseInt(stored, 10) : NaN;

        if (!Number.isNaN(storedScore)) {
          score = storedScore;
        } else {
          const fallbackScores = [316, 373, 420, 446, 511, 570, 610];
          score = fallbackScores[Math.floor(Math.random() * fallbackScores.length)];
          sessionStorage.setItem(storageKey, String(score));
        }
      }
    }
  
    // Вычисляем проценты и уровень заранее
    const percent = (score / maxScore) * 100;
    let level = 'low';
  
    if (percent <= 33) {
      level = 'low';
      tooltip.setAttribute('data-tooltip', 'У вас низкий кредитный рейтинг, из‑за этого некоторые компании могут ограничивать максимальную сумму выдачи');
    } else if (percent <= 66) {
      level = 'medium';
      tooltip.setAttribute('data-tooltip', 'У вас средний кредитный рейтинг, из‑за этого некоторые компании могут ограничивать максимальную сумму выдачи');
    } else {
      level = 'high';
      tooltip.setAttribute('data-tooltip', 'У вас хороший кредитный рейтинг, но некоторые компании всё равно могут ограничить максимальную сумму выдачи');
    }

    // Анимация счётчика
    $({ Counter: 0 }).animate(
      { Counter: score },
      {
        duration: 1000,
        easing: 'swing',
        step: function (val) {
          valueBlock.textContent = Math.ceil(val);
        },
        complete: function () {
          const active = meter.querySelector(`.score-meter__zone--${level}`);
          if (active) active.classList.add('score-meter__zone--active');

          valueStatus.classList.add(`score-meter__status--${level}`);
        }
      }
    );
});
  

document.addEventListener('DOMContentLoaded', () => {
  const openOfferModalBtn = document.querySelector('.open-offer-modal-btn');
  const offerModal = document.querySelector('.offer-modal');
  const offerModalClose = document.querySelector('.offer-modal__close');
  const overlay = document.querySelector('.overlay');

  if (!offerModal || !openOfferModalBtn) return;

  function openOfferModal() {
      offerModal.classList.toggle('is-visible');
      overlay.classList.toggle('is-active');
  }

  function closeOfferModal() {
      offerModal.classList.remove('is-visible');
      overlay.classList.remove('is-active');
  }

  openOfferModalBtn.addEventListener('click', openOfferModal);
  offerModalClose.addEventListener('click', closeOfferModal);

  document.addEventListener('click', (e) => {
      if (
          offerModal.classList.contains('is-visible') &&
          !offerModal.contains(e.target) &&
          !openOfferModalBtn.contains(e.target)
      ) {
          closeOfferModal();
      }
  });
});

